import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FileDownloadService } from '@services/file-download.service';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-file-download',
    templateUrl: './file-download.component.html',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class FileDownloadComponent implements OnInit {

  @ViewChild('link') link: ElementRef<HTMLAnchorElement>;

  constructor() { }

  ngOnInit(): void {
    this.watchItemsChanges();
  }

  watchItemsChanges() {
    FileDownloadService.items$
      .pipe(filter(items => items.length > 0))
      .subscribe((items) => {
        const newItems = [...items];
        const item = newItems.shift();
        this.downloadItem(item);
        FileDownloadService.items$.next(newItems);
      });
  }

  downloadItem(item: { url: string; fileTitle: string; }) {
    if (!item || !this.link?.nativeElement) {
      return;
    }
    this.link.nativeElement.href = item.url;
    this.link.nativeElement.download = item.fileTitle;
    this.link.nativeElement.click();
  }

}
